import React, {useEffect, useContext, useState} from "react";
import styled from "styled-components";
import {Header} from "@/components/Header";
import {Route, useHistory, useRouteMatch} from "react-router-dom";
import { WidgetInfoContext } from "@/utils/widgetInfoProvider";
import { Panel } from 'rsuite';

import './Main.css';
import SocialInfo from "@/pages/Overlay/SocialInfo";
import Editor from "@/pages/Overlay/Editor";
import OverlayWidget from "@/pages/Overlay/OverlayWidget";
import {fetchOverlayData, sendOverlayData} from "@/utils/backendUtils";

const Mobile = styled.div`
    display: flex;
    height: 100vh;
    background: #0E0F18;
    flex-direction: column;
`;


const Board = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 230px;
    background: #000000;
`;

const Block = styled.div`
    background: #141624;
    padding: 15px;
    margin-top: 1px;
    display: flex;
    justify-content: center;
`;

const Group = styled.div`
    padding: 0 15px;
`;
// window.userInfo = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1aWQiOiI2MyIsImF1dGgiOnRydWUsImlhdCI6MTY2MzMzMTY5MCwiZXhwIjoxNjY1OTIzNjkwfQ.OH8_GDjODozi9EAka4s92V1yIL5A4cJHVpc1s3DQWbI';
function Main() {
    const [test, setTest] = useState(null)
    const history = useHistory();
    const { path } = useRouteMatch();

    useEffect(() => {
        console.log(window?.getUserInfo)
    }, [])

    const goTo = (pathName) => {
        history.push(`${path}/${pathName}`)
    }

    const handleImageClick = async () => {
        await sendOverlayData();
    }

    return (
    <Mobile>
        <Header title={"Select widget type"}/>

        <Group>
            <Panel className={"glip_panel rs-theme-dark"} header={"Social media widget"} onClick={() => goTo('social')}>
                Add your instagram, facebook, twitch, whatsapp social handles
            </Panel>

            <Panel className={"glip_panel rs-theme-dark"} header={"Donation widget"} onClick={() => goTo('donation')}>
                Add your google pay, payTM, phonepe number
            </Panel>

            <Panel className={"glip_panel glip_panel-center"} onClick={handleImageClick}>
                + Upload an image
            </Panel>

            <div>
                {JSON.stringify(window?.getUserInfo) || 'test'}
            </div>
        </Group>
    </Mobile>
    );
}

/*
 {
    ui: {
        social: {
            layoutType: 'Neo',
            color: '#fsdfds',
            x: 'dsf',
            'y'
        },
        donation: {
            layoutType: 'Neo',
            color: '#fsdfds',
            x: 'dsf',
            'y'
        }
    },
    info: {
        social: {
            instagram: '@test'
        },
        donation: {
            number: '+7981',
            googlePay: true,
            phonePe: true,
            payTM: true
        }
    }
 }
 */

export default function Routes() {
    const [socialInfo, setSocialInfo] = useState(null);
    const [donationInfo, setDonationInfo] = useState(null);
    const [socialUI, setSocialUI] = useState(null);
    const [donationUI, setDonationUI] = useState(null);

    const [widgetColor, setWidgetColor] = useState(null);
    const [widgetScale, setWidgetScale] = useState(null);
    const { path } = useRouteMatch();

    useEffect(async () => {
        const result = await fetchOverlayData();
        const data = JSON.parse(result.data.data);

        if (data?.info) {
            setSocialInfo(data?.info?.social)
            setDonationInfo(data?.info?.donation)
        }

        if (data?.ui) {
            setSocialUI(data?.ui?.social)
            setDonationUI(data?.ui?.donation)
        }
    }, []);

    return (
        <WidgetInfoContext.Provider value={{
            socialInfo,
            donationInfo,
            widgetColor,
            widgetScale,
            setSocialInfo,
            setDonationInfo,
            setWidgetColor,
            setWidgetScale
        }}>
            <Route exact path={path} component={Main} />
            <Route path={`${path}/social`} component={SocialInfo} />
            <Route path={`${path}/editor`} component={Editor} />
            <Route path={`${path}/display`} component={OverlayWidget} />
        </WidgetInfoContext.Provider>
    );
}